import { useQuery } from '@tanstack/react-query'
import { bomCapturaApi } from '@/services/api'

/** Búsqueda de artículos (con BOM activo) por código o nombre — filtrado en servidor. */
export function useSistemas(q = '') {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['bom-sistemas', q],
    queryFn: () => bomCapturaApi.getSistemas(q),
    staleTime: 60 * 1000,
  })
  return { sistemas: data?.data ?? [], isLoading, isError }
}
